import {
  Button, DialogActions, DialogContent, Dialog, Divider, Grid, Typography, Checkbox, FormControlLabel
} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import React from 'react';
import { connect } from 'react-redux';
import { setHistoricalMaterialFilter } from 'src/store/actions/materialActions';
import { FaTree } from 'react-icons/fa';
import { AiOutlineFullscreen, AiOutlineFullscreenExit, AiOutlineCheckSquare } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import axios from 'src/utils/axios';
import { resetMaterials, getMaterialRequest } from 'src/store/actions';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
  DefectDiv: {
    margin: 0,
    padding: theme.spacing(1),

  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(0),
    top: theme.spacing(-1),
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    color: 'white',
    padding: '2px',

  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  chipRoot: {
    height: '72px',
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5),
    },
  }
}));

const DialogTitle = withStyles(styles)((props) => {
  const {
    children, classes, onClose, ...other
  } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} lg={12}>
          <Typography component="span">{children}</Typography>
        </Grid>
        <Grid item xs={12} sm={12} lg={12} style={{ textAlign: 'right' }}>
          {onClose ? (
            <Button color="primary" variant="contained" onClick={onClose} endIcon={<CheckCircleOutlineIcon />}>
              Done
            </Button>
          ) : null}
        </Grid>
      </Grid>


    </MuiDialogTitle>
  );
});

const SelectDialog = (props) => {
  const { t } = useTranslation('work_order');
  const [labelTumuDaralt, setlabelTumuDaralt] = React.useState(t('lblTumu'));

  const classes = useStyles();
  const handleChangeAgac = (e) => {
    props.setHistoricalMaterialFilter(e.target.checked ? 1 : 0);
  };
  const handleChangeFullMaterial = (e) => {
    props.setGosterimAdet(e.target.checked ? 100000 : 50);
    if (e.target.checked) {
      setlabelTumuDaralt(t('lblDaralt'));
    } else {
      setlabelTumuDaralt(t('lblTumu'));
    }
  };

  function loadMaterialHistory() {
    const RequestData = loadBaslandiJob();
    axios
      .get(`/GetMaterialHistoryBom/${RequestData[0]?.ModelCode}/${RequestData[0]?.ProductionYear || 0}/${RequestData[0]?.ProductionMonth || 0}`)
      .then(response => {
        props.resetMaterials();
        props.getMaterialRequest(RequestData[0]?.ModelCode, 1, 1, RequestData[0]?.ProductionYear || 0, RequestData[0]?.ProductionMonth || 0,RequestData[0]?.ReceiptNo|| 0);
      })
      .catch(error => {
      });
  }

  const loadMaterialCurrent = () => {
    const RequestData = loadBaslandiJob();
    props.resetMaterials();
    props.getMaterialRequest(RequestData[0]?.ModelCode, 1, 1, RequestData[0]?.ProductionYear || 0, RequestData[0]?.ProductionMonth || 0,RequestData[0]?.ReceiptNo|| 0);
  }


  return (
    <Dialog
      fullScreen
      open={props.open}
      onClose={props.onClose}
      onEntering={props.onEntering}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="customized-dialog-title" onClose={props.onClose}>
        <Typography component="span" variant="h6" gutterBottom>
          {props.title}
        </Typography>
        <Divider />
        <Divider color="secondary" />
        <Typography component="span" variant="body2" gutterBottom>
          {props.SelectedItems}
        </Typography>
      </DialogTitle>
      <DialogContent dividers className={classes.DefectDiv}>
        <Typography variant="h6" gutterBottom>
          {props.SearchField}
        </Typography>
        {props.children}
      </DialogContent>
      {props.actions
        && (
          <DialogActions>
            {props.isDefectDialog &&
              <>
                <Grid container spacing={1}>
                  <Grid item xs={6} sm={6} lg={6}>
                    <Button
                      color="secondary"
                      variant="contained"
                      fullWidth
                      onClick={() => loadMaterialCurrent()}
                      endIcon={<AiOutlineCheckSquare style={{ color: 'green' }} size="20" />}
                    >
                      {t('lblCurrent')}
                    </Button>
                  </Grid>
                  <Grid item xs={6} sm={6} lg={6}>
                    <Button
                      color="secondary"
                      variant="contained"
                      fullWidth
                      onClick={() => loadMaterialHistory()}
                      endIcon={<FaTree style={{ color: 'orange' }} size="20" />}
                    >
                      {t('lblHistory')}
                    </Button>
                  </Grid>
                </Grid>
              </>
            }
          </DialogActions>
        )}
    </Dialog>
  );
};


const mapStateToProps = (state) => (state);

const mapDispatchToProps = {
  setHistoricalMaterialFilter,
  resetMaterials,
  getMaterialRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectDialog);
